import React from 'react';
import PropTypes from 'prop-types';
import NoReportsScreen from 'routes/App/reports/ReportsTable/NoReportsScreen';
import {ButtonPrimary} from 'components/buttons';
import {DashboardField} from 'routes/App/dashboard/styles';

const SpecialOrdersReport = ({specialOrdersReportId}) => {
  return (
    <>
      {specialOrdersReportId ? (
        <DashboardField className='mTop30 justifyCenter'>
          <ButtonPrimary
            type='button'
            className='ButtonMedium'
            onClick={() =>
              window.open(
                `${process.env.REACT_APP_SPECIAL_ORDERS_REPORT_URL}/${specialOrdersReportId}`,
                '_blank'
              )
            }
          >
            <span>Go to your report</span>
          </ButtonPrimary>
        </DashboardField>
      ) : (
        <NoReportsScreen />
      )}
    </>
  );
};

SpecialOrdersReport.propTypes = {
  specialOrdersReportId: PropTypes.string.isRequired
};

export default SpecialOrdersReport;
